module.exports = __webpack_public_path__ + "static/img/kuaixiao.659939e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/kuaixiao.jpg
// module id = 385
// module chunks = 12